import { useEnum } from "@/api/services/global/enum";
import { usePersonInChargeOptions } from "@/api/services/main/user";
import { FieldGrid } from "@/features/company/components/FieldGrid";
import { TCompanyForm } from "@/features/company/types/company-form";
import { FormField } from "@/modules/irohana-components/elements/FormField";
import { Input } from "@/modules/irohana-components/elements/Input";
import { SelectNew } from "@/modules/irohana-components/elements/SelectNew";
import { findLabelByValue } from "@/utils/object";
import { FC } from "react";
import { useFormContext, useWatch } from "react-hook-form";

/**
 * 社内担当者・連携設定 section. 登録方法 is decided by how the company was created (手動登録 / visa連携 / match連携)
 * and is therefore shown read-only rather than as an editable select.
 */
export const InternalStaffSection: FC = () => {
  const { control } = useFormContext<TCompanyForm>();
  const registrationMethod = useWatch({ control, name: "registrationMethod" });
  const { data: registrationMethodOptions } = useEnum("EClientRegistrationMethod");
  // 主担当者はログインユーザーと同じ組織のユーザーのみ（サーバー側で絞り込み済み）。
  const { options: personInChargeOptions, isLoading: isLoadingPersonInCharge } = usePersonInChargeOptions();

  return (
    <FieldGrid>
      <FormField<TCompanyForm> name="mainPersonInChargeId" control={control} fullWidth>
        <SelectNew fullWidth options={personInChargeOptions} loading={isLoadingPersonInCharge} placeholder="選択内容" />
      </FormField>

      <FormField<TCompanyForm> name="registrationMethod" control={control} fullWidth>
        <Input fullWidth readonly clearable={false} nonControl value={findLabelByValue(registrationMethodOptions, registrationMethod)} />
      </FormField>
    </FieldGrid>
  );
};
